import React, { Component } from 'react'
import _ from 'lodash'
import {StripeProvider,
		injectStripe,
		CardElement,
		Elements} from 'react-stripe-elements'
import utils from '../utils'
import { removeShoppingCart } from '../functions/shopping-cart'

import config from "../actions/config"

class Card extends Component {
	state = {
		stripe: null,
		message: typeof document ? document.message : ''
	}

	componentDidMount() {
		if (window.Stripe) {
			this.setState({stripe: window.Stripe(config.stripe_key)});
		} else {
			document.querySelector('#stripe-js').addEventListener('load', () => {
				this.setState({stripe: window.Stripe(config.stripe_key)});
			})
		}
	}

	changeMessage = event => {
		this.setState({ message: event.target.value })
		document.message = event.target.value
	}

	render() {
		this.props.cleanShoppingCart()
		const shoppingCart = this.props.shoppingCart
		const offers = this.props.offers
		const fee_ht = 15
		const fee_ttc = fee_ht * 1.2
		const total_ht = fee_ht + _.sum(_.map(shoppingCart, ({quantity, offer_id}) => {
			const offer = _.find(this.props.offers, o => o.offer_id == offer_id) || {}
			const price_ht = (_.find(offer.price, p => p.from <= quantity && (p.to && quantity <= p.to || !p.to)) || {price_ht: 0}).price_ht
			const price_ttc = price_ht * 1.2

			return price_ht * quantity
		}))
		const total_ttc = total_ht * 1.2
		const deliveryDate = utils.addBusinessDays(document.selectedDay, 3).format('dddd LL')
		const { message } = this.state

		return (
			<section className="w60 tiny-w100 bgc--inverse tiny-ptxl large-plxl large-prxl extra-large-plxl extra-large-prxl ptm pbl zi1">
				<div className="pll prl">
					<div className="ptl pbl mtm"><div className="btn--unstyled u-secondary-bold u-big" onClick={this.props.goBack}><span className="prs">&#60;</span>Retour au contact de paiement</div></div>
					<h1 className="h3-like pbm">Informations de paiement</h1>
					<h2 className="h4-like pbs">Commande</h2>
					<div className="mbl ptm pbm bgc--inverse bdra--m bd--t">
						<div className="tiny-pls tiny-prs plm mls prm mrs d-flex u-small">
							<span className="d-inbl lnr lnr-rocket u-bigger mrs prs"></span>
							<span className="flex-item-fluid">
								<span className="tiny-w100 prt">
									<span>Livraison des images</span>
								</span>
								<span className="small-w100 large-w100">
									<span className="u-italic prs">{deliveryDate}</span>
									<span className="fr"></span>
								</span>
							</span>
						</div>

						<div className="tiny-pls tiny-prs plm mls prm mrs mts">
							{
								_.map(shoppingCart, ({offer_id, quantity}) => {
									const offer = _.find(this.props.offers, o => o.offer_id == offer_id) || {}
									console.log("offer = ", offer)
									const price_ht = (_.find(offer.price, p => p.from <= quantity && (p.to && quantity <= p.to || !p.to)) || {price_ht: 0}).price_ht
									const total = price_ht * quantity

									return (
										<div className="d-flex pbm" key={offer_id}>
											<div className="w70p h70p mrm tiny-mrs bdra--s of-hidden">
												<img className="d-inbl w100 h70p bgc--tertiary bdra--s" src={utils.getImgPath(_.first(offer.images))} alt=""  style={{objectFit: 'contain'}}/>
											</div>
											<div className="flex-item-fluid u-small mauto">
												<p className="d-flex flex-align-baseline">
													<span className="tiny-w100 small-w100 prs">{offer.smalltext}</span>
													<span className="u-small u-italic prs">{'(' + (offer.nb_image > 1 ? (offer.nb_image == 3 ? (offer.nb_image - 1) + ' vues' : offer.nb_image + ' vues') : offer.nb_image + ' vue') + (offer.smalltext == "Ghost" ? " + détail offert" : "") + ')'}</span>
													<span className="color--disabled flex-item-noshrink txtright">{utils.printPrice(price_ht)}€</span>
												</p>
												<div className="txtright">
													<span>{'x' + quantity}</span>
													<span className="plm">{utils.printPrice(total) + '€'}</span>
												</div>
											</div>
										</div>
									)
								})
							}
						</div>
						<hr className="tiny-mts mam"/>
						<div className="tiny-pls tiny-prs plm mls prm mrs d-flex u-small">
							<span className="d-inbl lnr lnr-rocket u-bigger mrs prs"></span>
							<span className="flex-item-fluid">
								<span className="tiny-w100 prt">
									<span>Coursier :</span>
								</span>
								<span className="small-w100 large-w100">
									<span className="u-italic prs"></span>
									<span className="fr">15€</span>
								</span>
							</span>
						</div>
						<hr className="mam"/>
						<div className="tiny-pls tiny-prs plm mls prm mrs u-small">
							<div className="d-flex">
								<span className="d-inbl lnr lnr-pencil u-bigger mrs prs"></span>
								<span className="flex-item-fluid">Un petit mot pour le photographe <span className="u-italic u-small">(facultatif)</span>&nbsp;:</span> 
							</div>
							<div>
								<textarea className='w100 mtm' rows='4' value={message} onChange={this.changeMessage} />
							</div>
						</div>
						<hr className="mam"/>
						<div className="tiny-pls tiny-prs plm mls prm mrs">
							<div className="d-flex flex-space-between u-bold pbs">
								<span>Total HT</span>
								<span>{utils.printPrice(total_ht) + '€'}</span>
							</div>
							<div className="d-flex flex-space-between u-small color--disabled">
								<span>Total TTC</span>
								<span>{utils.printPrice(total_ttc) + '€'}</span>
							</div>
						</div>
					</div>
					<h2 className="h4-like pbs">Paiement</h2>
					<StripeProvider stripe={this.state.stripe}>
						<Elements>
							<CheckoutForm
								nextStep={this.props.nextStep}
							/>
						</Elements>
					</StripeProvider>
				</div>
			</section>
		)
	}
}

class _CheckoutForm extends Component {
	state = {
		error:null,
		disabled: false
	}
	handleSubmit = (ev) => {
		ev.preventDefault()
		this.setState({ disabled: true })
		this.props.stripe.createToken().then(res => {
			if(!res.token || !res.token.id ) {
				this.setState({error:"Une erreur est survenue. Veuillez contrôler les informations de votre carte.", disabled: false})
				return
			}
			this.props.nextStep({token: res.token.id, type: res.token.type})
		}).catch(err => {
			console.error(err)
			this.setState({disabled: false})
		})
	}
	render = () => {
		const { disabled } = this.state

		return (
			<div>
				<form onSubmit={this.handleSubmit}>
					<p className="color--primary-darken u-small u-italic">{this.state.error}</p>
					<CardSection />
					<p className="mts plm color--disabled u-small italic">Ex. : 4242 4242 4242 4242</p>
					<button className='mtl btn--secondary btn--big fr' disabled={disabled}><span className="pll prl">Payer</span></button>
				</form>
			</div>
		)
	}
}
const CheckoutForm = injectStripe(_CheckoutForm)

class CardSection extends Component {
	render() {
		return (
			<CardElement
				style={{
					base: {
						fontSize: '15px',
						fontFamily: '"Avenir medium", Helvetica Neue", Helvetica, sans-serif',
					    fontSmoothing: 'antialiased',
						color: '#292828',
						'::placeholder': {
      						color: '#acb3c2'
    					}
    				}
    			}}
    		/>
		)
	}
}

class CheckCard extends Component {
	render() {
		return (
			<div>On check ta carte ...</div>
		)
	}
}

export default Card
export {CheckCard}


// WEBPACK FOOTER //
// ./src/components/Card.js